import { message } from "antd";

/**
 * Hook aprimorado para mensagens globais do Ant Design.
 * Suporta await, empilhamento, e previne sumiço por desmontagem.
 */
export const useMensagensService = () => {
  const [messageApi, contextHolder] = message.useMessage();

  // 🔹 Configuração padrão
  const defaultConfig = {
    duration: 3,
    style: {
      marginTop: "60px", // desloca para não sobrepor appbar
    },
  };

  // 🔹 Helper para empilhar mensagens (sem substituir)
  const show = async (
    type: "success" | "error" | "warning" | "info" | "loading",
    content: string,
    duration?: number
  ) => {
    // `messageApi.open` retorna uma Promise — aguardamos se o chamador quiser
    return await messageApi.open({
      key: `${type}-${Date.now()}`, // chave única → empilha
      type,
      content,
      duration: duration ?? defaultConfig.duration,
      style: defaultConfig.style,
    });
  };

  // 🔹 Métodos simplificados
  const sucesso = (texto: string, duration = 3) => show("success", texto, duration);
  const erro = (texto: string, duration = 5) => show("error", texto, duration);
  const aviso = (texto: string, duration = 4) => show("warning", texto, duration);
  const info = (texto: string, duration = 3) => show("info", texto, duration);
  const carregando = (texto = "Carregando...", duration = 0) =>
    show("loading", texto, duration);

  return {
    sucesso,
    erro,
    aviso,
    info,
    carregando,
    contextHolder,
  };
};
